var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('p',{ref:"a"},[_vm._v("\n        "+_vm._s(_vm.pages[_vm.currentPage])+"\n    ")]),_c('p',{ref:"hidden",staticClass:"hidden"})])}
var staticRenderFns = []

export { render, staticRenderFns }